import {getCurrentUserLogin} from '@github-ui/client-env'
import type {Thread} from '@github-ui/diff-lines/conversation-types'

import {useAllThreads} from '../../../../stores/layout-selectors'

export function selectReviewThreadsStartedByUser(threads: Thread[], userLogin: string | undefined): Thread[] {
  if (!userLogin) return []

  return threads.filter(thread => thread.commentsData?.comments[0]?.author?.login === userLogin)
}

export function useReviewThreadsStartedByCurrentUser(): Thread[] {
  const threads = useAllThreads()
  return selectReviewThreadsStartedByUser(threads, getCurrentUserLogin())
}
